<template>
    <div id="tglLists">
        <div id="headers">
            <!-- <i class="arr" @click="goBack()"></i> -->
            <p class="title">{{title}}</p>
            <p>{{mobile}}--<a href="javascript:;" @click="outLogin">退出登录</a></p>
        </div>
        <div class="listBox">
            <div class="setFix"></div>
            <p class="wranTop">请严格保护用户隐私，禁止任何形式的非法复制、传播和使用用户信息</p>
            <!-- <form method="post" action=""  onsubmit="return false;">
                <input type="search" class="ipt" placeholder="搜索小区" v-model="value" @keyup="searchVal" autofocus ref="keyIpt">
            </form> -->
            <div class="tableBox">
                <table>
                    <tr class="row clearfix">
                        <th class="name">小区</th>
                        <th>登记记录</th>
                        <th>出入记录</th>
                        <th class="opeare">操作</th>
                    </tr>
                    <tr class="row row-item clearfix" v-for="(item,index) in communitys" :key="index">
                        <td class="ctxt areaname nowrap" >{{item.community}}</td>
                        <td class="ctxt djjl" @click="intoDjgl(1,item.poiId)">{{item.reg_nums}}</td>
                        <td class="ctxt crjl" @click="intoDjgl(2,item.poiId)">{{item.sign_logs}}</td>
                        <td class="ctxt zqzgl" @click="intoDjgl(3,item.poiId)">执勤者管理</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="noLists" v-show="noShow && communitys.length == 0">
            <img src="~@/assets/imgs/bg.png" alt />
            <p>暂无数据~</p>
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import axios from 'axios'
import { Indicator, Toast } from 'mint-ui';
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'小区列表',
            username:null,
            mobile:null,
            value:'',
            communitys:[],
            noShow:false,
            len:''
        }
    },
    created() {
        // 判断登录未登录
        // this.setuserToken("wr7w4pRzr4pK8a5ZC090rM8K7Jm95Acz")
        // this.getLists()
        axios.post(this.commonIp()+'/v1/mobile/community/userInfo')
        .then((res) => {
            if(res.data.code=='200') {
                this.setuserToken(res.data.data.token)
                this.getLists()
            }else if(res.data.code == '424'||res.data.code == '423'){
                if (this.isAndroid() || this.isIos()) {
                    window.location.href = "app://login";
                } else {
                    // lng=116.467125&lat=39.996747
                    window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                }
            }
        })
    },
    mounted() {
    },
    methods:{
        goBack() {
            this.$router.go(-1)
            // this.$router.push({path:`/mcenter?poiId=${this.$route.query.poiId}`})
        },
        outLogin() {
          this.setuserToken('')
          window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
        },
        searchVal(e) {
            if(!e) e = window.event;
            if(e.keyCode ==13){
                this.value = e.target.value
                this.$refs.keyIpt.blur()
            }
        },
        intoDjgl(type,poiId) {
            if(type=='1') {
                this.$router.push({path:`/records?poiId=${poiId}`})
            }else if(type=='2'){
                this.$router.push({path:`/crrecords?poiId=${poiId}`})
            }else{
                this.$router.push({path:`/zqzmg?poiId=${poiId}`})
            }
        },
        getLists() {
            if(this.getuserToken()) {
                axios.post(this.commonIp()+'/v1/mobile/community/manage',{
                    token:this.getuserToken()
                }).then((res) => {
                    if(res.data.code=='200') {
                        this.username = res.data.data.username
                        this.mobile = res.data.data.mobile
                        if(res.data.data.communitys.length==0) {
                            this.noShow = true
                        }else{
                            this.communitys = res.data.data.communitys
                        }
                    }else if(res.data.code=='424') {
                        if (this.isAndroid() || this.isIos()) {
                            window.location.href = "app://login";
                        } else {
                            // lng=116.467125&lat=39.996747
                            window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                        }
                    }
                    
                })
            }
            
        }
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    #tglLists{
        // max-width: 750px;
        // margin:0 auto;
        .setFix{
            height:60px;
            border-bottom:1px solid #d8d8d8;
        }
        .ipt{
            position: relative;
            width: 86%;
            margin:10px 0 0 7%;
            border:1px solid #d8d8d8;
            background-image:url('~@/assets/imgs/s2.png');
            background-repeat: no-repeat;
            background-position: 10px center;
            background-color:#f2f2f2;
            background-size:13px;
            padding-left:32px;
            height:29px;
            outline: none;
            border-radius:4px;
            box-sizing: border-box;
        }
        .tableBox{
            table{
                margin-top:20px;
                width: 100%;
                display: inline-block;
                .row{
                    display: inline-block;
                    border-bottom:1px solid #d8d8d8;
                    width: 100%;
                    padding:0 15px;
                    text-align: center;
                    padding:15px;
                    cursor: pointer;
                    box-sizing: border-box;
                    td{
                        display: inline-block;
                        &.ctxt{
                            width:20%;
                            .fl();
                            color:#60a2e2;
                        }
                        &.areaname{
                            width:35%;
                            color:#333;
                        }
                        &.zqzgl{
                            width:25%;
                        }
                    }
                    th{
                        .fl();
                        width:20%;
                        text-align: center;
                        &.name{
                            width:35%;
                        }
                        &.opeare{
                            width:25%;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/gllist/gllist.vue